import { render, staticRenderFns } from "./ContentColumn.vue?vue&type=template&id=6ef11e75&"
import script from "./ContentColumn.vue?vue&type=script&lang=js&"
export * from "./ContentColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports